import constants from 'constants';
const {
  ADD_HOSPITAL_SUGGESTIONS,
  LOAD_HOSPITALS_SAGA,
  NEW_HOSPITAL_SUGGESTION,
  LOAD_COUNTIES_SAGA,
  LOAD_BRANCHES_SAGA,
  LOAD_COUNTRIES_SAGA,
  ADD_COUNTY_SUGGESTIONS,
  ADD_BRANCH_SUGGESTIONS,
  ADD_COUNTRIES_SUGGESTIONS,
  ADD_SPONSOR_SUGGESTIONS,
  ADD_PARTNER_SUGGESTIONS,
  ADD_SPONSOR_USERS_SUGGESTIONS,
  LOAD_SPONSORS_SUGGESTIONS_SAGA,
  LOAD_PARTNERS_SUGGESTIONS_SAGA,
  LOAD_SPONSOR_USERS_SUGGESTIONS_SAGA,
} = constants;

export const addHospitalSuggestions = (q, suggestions) => ({
  type: ADD_HOSPITAL_SUGGESTIONS,
  q,
  suggestions
})

export const newHospitalSuggestion = (suggestion) => ({
  type: NEW_HOSPITAL_SUGGESTION,
  suggestion
})

export const loadHospitalsSaga = (q) => ({
  type: LOAD_HOSPITALS_SAGA,
  q
})

export const loadCountiesSaga = () => ({
  type: LOAD_COUNTIES_SAGA
})

export const loadBranchesSaga = () => ({
  type: LOAD_BRANCHES_SAGA
})

export const loadCountriesSaga = () => ({
  type: LOAD_COUNTRIES_SAGA
})

export const loadSponsorsSuggestionsSaga = (q = '') => ({
  type: LOAD_SPONSORS_SUGGESTIONS_SAGA,
  q
})

export const loadPartnersSuggestionsSaga = (q = '') => ({
  type: LOAD_PARTNERS_SUGGESTIONS_SAGA,
  q
})

export const loadSponsorUsersSuggestionsSaga = (q = '', params) => ({
  type: LOAD_SPONSOR_USERS_SUGGESTIONS_SAGA,
  q,
  params,
});

export const addCountySuggestions = (suggestions) => ({
  type: ADD_COUNTY_SUGGESTIONS,
  suggestions
})

export const addBranchSuggestions = (suggestions) => ({
  type: ADD_BRANCH_SUGGESTIONS,
  suggestions
})

export const addCountriesSuggestions = (suggestions) => ({
  type: ADD_COUNTRIES_SUGGESTIONS,
  suggestions
})

export const addSponsorSuggestions = (suggestions) => ({
  type: ADD_SPONSOR_SUGGESTIONS,
  suggestions
})

export const addPartnerSuggestions = (suggestions) => ({
  type: ADD_PARTNER_SUGGESTIONS,
  suggestions
})

export const addSponsorUsersSuggestions = suggestions => ({
  type: ADD_SPONSOR_USERS_SUGGESTIONS,
  suggestions,
});


// WEBPACK FOOTER //
// ./src/actions/suggestions.js